export const cardName: any = {
  keyMetrics: 'Key Metric',
  activityOverTime: 'Activity Over Time',
  visitorsEngagement: 'Visitors Engagement',
  topPerformingTools: 'Top Performing Tools',
  contributionTags: 'Contribution Tags',
  contributionsLocation: 'Contributions Location',
}

export const cardType: any = {
  keyMetrics: 'Key Metric',
  activityOverTime: 'Area chart',
  visitorsEngagement: 'Funnel chart',
  topPerformingTools: 'Table',
  contributionTags: 'Bar chart',
  contributionsLocation: 'Map',
}

export const intervalType: any = {
  all_time: 'All time',
  last_7_days: 'Last 7 days',
  last_30_days: 'Last 30 days',
  custom: 'Custom',
}
